import React from 'react';
import { ChevronDown } from 'lucide-react';

export function QuizrrStepperSkeleton() {
    return (
        <div className="border-t-1 border-b-1 py-3 w-full px-4 md:px-2 md:border-none md:pt-0 mb-4">
            <div className="mb-6 flex items-start justify-between">
                <div className="flex flex-col text-[var(--q3-neutral-default)] lg:flex-row items-start lg:items-center gap-0 md:gap-3">
                    <div className="h-8 w-48 bg-[var(--q3-surface-dimmer)] rounded-md mb-2"></div>
                    <div className="h-5 w-72 bg-[var(--q3-surface-dimmer)] rounded-md"></div>
                </div>
                <div className="h-8 w-20 bg-[var(--q3-surface-dimmer)] rounded-lg"></div>
            </div>

            <div className="divide-y divide-[var(--q3-stroke-normal)] rounded-lg border-2">
                {[1, 2, 3, 4].map((item) => (
                    <div key={item} className="overflow-hidden rounded-t-lg">
                        <div className="flex w-full items-center justify-between p-4 text-left bg-[var(--q3-surface-default)]">
                            <div className="flex items-center gap-3">
                                <div className="h-8 w-8 rounded-full bg-[var(--q3-surface-dimmer)]"></div>
                                <div className="h-6 w-56 bg-[var(--q3-surface-dimmer)] rounded-md"></div>
                            </div>
                            <div className="bg-[var(--q3-surface-dimmer)] rounded-full p-1">
                                <ChevronDown size={18} className="text-gray-300" />
                            </div>
                        </div>
                        {item === 1 && (
                            <div className="bg-[var(--q3-surface-dim)] px-4 pb-4">
                                <div className="flex items-center py-4">
                                    <div className="mr-4 h-5 w-8 bg-[var(--q3-surface-dimmer)] rounded-md"></div>
                                    <div className="flex flex-1 flex-col md:flex-row md:gap-6">
                                        <div className="relative mb-4 h-36 w-[250px] bg-[var(--q3-surface-dimmer)] rounded-lg md:mb-0 md:w-[250px] md:flex-shrink-0"></div>
                                        <div className="flex flex-1 flex-col">
                                            <div className="h-7 w-full bg-[var(--q3-surface-dimmer)] rounded-md mb-4"></div>
                                            <div className="flex flex-wrap gap-2 mt-auto">
                                                <div className="h-10 w-36 bg-[var(--q3-surface-dimmer)] rounded-full"></div>
                                                <div className="h-10 w-48 bg-[var(--q3-surface-dimmer)] rounded-full"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}